import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import logo from './logo.png';
import { BsTwitter } from 'react-icons/bs';

function Navbar() {
  const [activePage, setActivePage] = useState('about'); // Initialize with 'about' as the active page

  function handlePageClick(page) {
    setActivePage(page);
  }

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/" onClick={() => handlePageClick('about')}>
          <img className='logo-navbar' src={logo} alt="Logo" />
        </Link>
      </div>
      <ul className="nav-options">
        <li>
          <Link
            to="/"
            className={activePage === 'about' ? 'active' : ''}
            onClick={() => handlePageClick('about')}>
            ¿Nosotros qué?
          </Link>
        </li>
        <li>
          <Link
            to="/library"
            className={activePage === 'library' ? 'active' : ''}
            onClick={() => handlePageClick('library')}>
            Libreria de Hilos
          </Link>
        </li>
        <li>
          <a target="_blank" rel="noreferrer" href="https://twitter.com/EconFinTalked">
            <BsTwitter className='Icons' />
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
